import React from 'react';

const Input = React.forwardRef(({
    onChangeHandler,
    placeholder = '',
    className = '',
    icon = null,
    onKeyDown,
    onFocus,
    value= "",
}, ref) => (
    <div className={`input ${className}`}>
        {icon && <img className="input__icon" src={icon} />}
        <input
            ref={ref}
            className="input__element"
            type="text"
            value={value}
            onChange={onChangeHandler}
            placeholder={placeholder}
            onKeyDown={onKeyDown}
            onFocus={onFocus}
        />
    </div>
));

export default Input;
